<template>
  <div>
    <div class="y-cust-search-ctr" v-if="showSearch">
      <el-autocomplete
        prefix-icon="el-icon-search"
        v-model="queryString"
        select-when-unmatched
        :fetch-suggestions="querySearch"
        @change="searchParamkey(queryString)"
        @keyup.native="resetForm(queryString)"
        @select="searchParamkey(queryString)"
        @clear="clearSearch"
        :trigger-on-focus="false"
        placeholder="Search"
        type="text"
        class="custom-icon cust-search-input"
        clearable
      ></el-autocomplete>
    </div>
    <div>
      <div v-if="showSearchField" class="y-search-form-ctr">
        <cust-conditional-render :dataProps="searchFormField" />
      </div>
      <div class="y-cust-form-ctr" v-else>
        <el-collapse accordion class="y-cust-accordion-ctr">
          <div v-for="item in loadedParams" :key="item.title">
            <el-collapse-item
              :label="item.title"
              :title="item.title"
              :name="item.title"
              :autoid="item.autoid"
              @click.native="
              showHighlight(item.highlight_class),
              switchPreviewPage(item.previewPageName)
            "
            >
              <div class="y-form-row" v-for="(component, index) in item.form" :key="index">
                <cust-conditional-render :dataProps="component" />
              </div>
            </el-collapse-item>
          </div>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import CustConditionalRender from '../../components/custConditionalRender.vue'
import { mapActions } from 'vuex'
import { custToolHelper } from '../../mixins/custToolHelper'
import _ from 'underscore'
export default {
  name: 'cust-features-tab',
  $_veeValidate: {
    validator: 'new'
  },
  provide() {
    return {
      $validator: this.$validator
    }
  },
  data() {
    return {
      queryString: '',
      compStoreName: 'paramStore',
      showSearch: false
    }
  },
  created() {
    this.$store.state.paramStore.showSearchField = false
  },
  mounted() {
    this.showHideDependKeys()
  },
  mixins: [custToolHelper],
  components: {
    'cust-conditional-render': CustConditionalRender
  },
  watch: {
    loadedParams: {
      deep: true,
      handler: 'updateDataSavedStatus'
    }
  },
  props: {},
  computed: {
    loadedParams() {
      return this.$store.state.paramStore.loadedParams
    },
    showSearchField() {
      return this.$store.state.paramStore.showSearchField
    },
    searchFormField() {
      return this.$store.state.paramStore.searchFormField
    }
  },
  methods: {
    ...mapActions(['searchParamkey']),
    validateParamData() {
      console.log('Inside validate method features--->')
      return this.$validator.validateAll()
    },
    getSearchData() {
      return this.$store.state.paramStore.loadedParams
    },
    resetForm(queryString) {
      if (queryString == '') {
        this.$store.state.paramStore.showSearchField = false
      }
    },
    filterKey(object, result) {
      if (object.hasOwnProperty('dependend_ref_ids')) result.push(object)
      for (var i = 0; i < Object.keys(object).length; i++) {
        if (typeof object[Object.keys(object)[i]] == 'object') {
          this.filterKey(object[Object.keys(object)[i]], result)
        }
      }
      return result
    },
    showHideDependKeys() {
      let obj = this.loadedParams
      let result = []
      let dependRefIdObjs = this.filterKey(obj, result)
      if (dependRefIdObjs) {
        for (var i = 0; i < dependRefIdObjs.length; ++i) {
          if (dependRefIdObjs[i] && dependRefIdObjs[i].dependend_ref_ids) {
            let dependRefIds = dependRefIdObjs[i].dependend_ref_ids
            for (var j = 0; j < dependRefIds.length; ++j) {
              if (
                dependRefIdObjs[i].defaultValue ===
                dependRefIdObjs[i].showDependendKeysOn
              ) {
                $('.' + dependRefIds[j]).show()
              } else {
                $('.' + dependRefIds[j]).hide()
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style>
</style>
